<template>
  <div class="fees-record">
    <v-row>
      <v-col cols="7" md="8">
        <h1 class="text-left mx-4">Fees Data</h1>
      </v-col>
      <v-col cols="5" md="4">
        <v-btn v-if="currentUser.privileges.canManageFeeSettings" color="primary" rounded outlined small class="my-2" :to="{name: 'FeeSettings'}">Fee Settings</v-btn>
      </v-col>
    </v-row>
    <v-row justify="end">
      
    </v-row>
    <v-row>
      <v-col cols="12" md="9">
        <!-- counts -->
        <v-col cols="12" md="12" lg="12">
          <FeeCards @payment_status="changePaymentFilter" :counts="counts" v-if="counts" />
        </v-col>
        <!-- analytics mobile-->
        <v-col cols="12" md="4" class="hidden-md-and-up">
          <v-select 
          v-if="currentUser.privileges.canChangeFeeSessions"
            v-model="activeFeeSession"
            :items="feeSessionData"
            outlined
            color="primary"
            label="Academic Year"
            return-object
            hide-details
            dense
            background-color="white"
            item-value="id"
            item-text="title"
            class="mx-4 my-4 rounded-input"
            @change="changeActiveSession"
          ></v-select>
          <div v-if="currentUser.privileges.canViewStudentFeeStatus">
            <h3 class="mb-2">Fee Analytics</h3>
            <FeeAnalytics
            width="300"
              :series="[counts.paid, counts.due, counts.overdue]"
              :labels="['Paid', 'Due', 'Overdue']"
            :colors="['#4CD137', '#FF7700', '#FF0000']"
            />
          </div>
          
        </v-col>

        <!-- fee record -->
        <v-col cols="12" md="12" class="pr-0">
          <v-card class="mx-4 my-4">
            <v-card-title>
              Fees Record
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                class="pb-2"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
              <download-excel
                v-if="currentUser.privileges.canExportFeeAccounts"
                :fetch="getExportData"
                :fields="export_fields"
                :name="getExportName"
              >
                <v-btn
                  class="ml-3 text-right"
                  :loading="export_in_progress"
                  :disabled="export_in_progress"
                  color="white"
                  elevation="1"
                >
                  Export
                  <v-icon right dark> mdi-export </v-icon>
                  <template v-slot:loader>
                    <span class="custom-loader">
                      <v-icon light>mdi-cached</v-icon>
                    </span>
                  </template>
                </v-btn>
              </download-excel>
            </v-card-title>
             <!-- filter -->
              <v-row class="mx-4">
                <v-col cols="12" md="4">
                  <v-select
                    v-model="filter.category"
                    :items="categories"
                    small-chips
                    deletable-chips
                    single-line
                    outlined
                    color="primary"
                    label="Filter by Category"
                    multiple
                    hide-details
                    dense
                    background-color="transparent"
                    item-value="code"
                    item-text="code"
                    class="mb-4 rounded-input"
                    @change="getAllFeeRecords()"
                  ></v-select>
                </v-col>

                <v-col cols="12" md="4">
                  <v-select
                    v-model="filter.room"
                    :items="rooms"
                    small-chips
                    deletable-chips
                    outlined
                    color="primary"
                    label="Filter by Classroom"
                    multiple
                    hide-details
                    dense
                    background-color="transparent"
                    item-value="id"
                    item-text="sections"
                    class="mb-4 rounded-input"
                    @change="getAllFeeRecords()"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="filter.status"
                    :items="['Paid', 'Due', 'Overdue', 'Upcoming']"
                    small-chips
                    deletable-chips
                    outlined
                    color="primary"
                    label="Filter by Payment Status"
                    multiple
                    hide-details
                    dense
                    background-color="transparent"
                    class="mb-4 rounded-input"
                    @change="getAllFeeRecords()"
                  ></v-select>
                </v-col>
              </v-row>


              <!-- filter end -->
            <v-data-table
              :headers="headers"
              :items="records"
              :search="search"
              :options.sync="options"
              :items-per-page="15"
              :multi-sort="true"
              :server-items-length="pagination.totalCount"
              @click:row="handleClick"
              class="row-pointer"
            >
              <template v-slot:item.full_name="{item}">
                <span class="font-weight-bold">{{ item.student.full_name }}</span>
              </template>
              <template v-slot:item.phone="{item}">
                <span class="font-weight-bold">{{ item.student.phone }}</span>
              </template>
              <template v-slot:item.room="{ item }">
                <v-chip color="primary" small outlined>
                  <!-- <h5 v-if="item.student.room">{{ item.student.room.sections }}</h5> -->
                  <h5 v-if="item.room">{{ item.room.sections }}</h5>
                  <h5 v-else>Not Assigned</h5>
                </v-chip>
              </template>
              <template v-slot:item.status="{ item }">
                <v-chip color="#4CD137" small outlined v-if="item.status == 'Paid'">
                  <h5>Paid</h5>
                </v-chip>
                <v-chip color="#FF7700" small outlined v-else-if="item.status == 'Due'">
                  <h5>Due</h5>
                </v-chip>
                <v-chip color="#FF0000" small outlined v-else-if="item.status == 'Overdue'">
                  <h5>Overdue</h5>
                </v-chip>
                <v-chip color="#4CD137" small outlined v-else-if="item.status == 'Upcoming'">
                  <h5>Upcoming</h5>
                </v-chip>
                <v-chip color="#000000" small outlined v-else>
                  <h5>-</h5>
                </v-chip>
              </template>
              <template v-slot:item.category="{item}">
                <v-chip color="primary" small outlined>
                  <h5 v-if="item.category">{{ item.category.code }}</h5>
                  <h5 v-else>Not Assigned</h5>
                </v-chip>
              </template>
              <template v-slot:item.image="{item}">
                <v-avatar width="30" height="30">
                  <img :src="item.student.image" />
                </v-avatar>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-col>
      <!-- analytics lg-->
      <v-col cols="12" md="3" class="hidden-sm-and-down">
        
        <v-select
          v-if="currentUser.privileges.canChangeFeeSessions"

          v-model="activeFeeSession"
          :items="feeSessionData"
          outlined
          color="primary"
          label="Academic Year"
          return-object
          hide-details
          dense
          background-color="white"
          item-value="id"
          :item-text="item=>`${item.title} ${ item.active? '(Active)' : '' }`"
          class="mx-4 my-4 rounded-input"
          @change="changeActiveSession"
        ></v-select>
        <div v-if="currentUser.privileges.canViewStudentFeeStatus">
          <h2 class="mb-2">Fee Analytics</h2>
          <FeeAnalytics
            :series="[counts.paid, counts.due, counts.overdue]"
            :labels="['Paid', 'Due', 'Overdue']"
            :colors="['#4CD137', '#FF7700', '#FF0000']"
          />
        </div>
        
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbar.visible">
      {{ snackbar.text }}
      <template>
        <v-btn color="pink" text @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import FeeCards from "@components/fees/FeeCards.vue";
import FeeAnalytics from "@components/fees/FeeAnalytics.vue";
import { mapGetters, mapActions } from "vuex";
import api from "@api/index";
import endpoints from "@api/repository";
import JsonExcel from "vue-json-excel";
import Helper from "@utils/misc";

export default {
  name: "FeesRecord",
  components: {
    FeeCards,
    FeeAnalytics,
    downloadExcel: JsonExcel,
  },

  data() {
    return {
      options: {},
      pagination: {
        totalCount: 0,
        url: endpoints.getAllFeeRecords,
      }, 
      search: "",
      filter: {
        category: null,
        room: null,
        status: null,
      },
      categories: [],
      counts: {
        paid: 0,
        due: 0,
        overdue: 0
      },
      headers: [
        { text: "Photo", value: "image", align: "center", sortable: false },
        { text: "Name", align: "center", value: "full_name" },
        { text: "Phone Number", align: "center", value: "phone" },
        { text: "Classroom", value: "room", align: "center" },
        { text: "Category", value: "category", align: "center" },
        { text: "Status", value: "status", align: "center" },
      ],
      records: [],
      rooms: [],

      snackbar: {
        visible: false,
        text: "",
      },
      export_in_progress: false,
      export_fields: {
        "Full Name": "full_name",
        "Phone no.": "phone",
        "Classroom": "classroom",
        "Fee Category": "category",
        "Status": "status",
       
      },
    };
  },
  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading","feeSessionData","activeFeeSession",]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
getExportName() {
      return Helper.getExportName();
    },


  },

  methods: {
    ...mapActions(["setLoading","setActiveSessionData"]),

    async getFeeRecordsCounts() {
      // console.log("getting counts");
      var url = Helper.addUrlParams(endpoints.getFeeRecordsCounts, `session=${this.activeFeeSession.id}`);
      this.counts = await api.call(
        this.essentials,
        url
      );
    },

    changePaymentFilter(status){
      this.$set(this.filter, 'status',[status]);
      this.getAllFeeRecords();
    },
    
    async changeActiveSession(session){
      this.setActiveSessionData(session);
      window.location.reload()
    },
    // queries all fee categories
    async getAllCategories() {
      var response;
      var url = endpoints.getAllCategories + `?session=${this.activeFeeSession.id}`;
      response = await api.handleApi({
        url: url,
        apiEssentials: this.essentials,
        responseVar: response,
      });

      if (response) {
        this.categories = response;
      }
    },

    // quries rooms
    async getRooms() {
      var response;
      var url = endpoints.getRooms;

      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: url,
        responseVar: response,
      });

      if (response instanceof Error) {
        this.setLoading(false);
        this.snackbar.text = "Error retrieving rooms";
        this.snackbar.visible = true;
        return;
      }
      this.rooms = response;
    }, 

    // queries all fee accounts
    async getAllFeeRecords() {
      // debugger;
      var response;
      var url = Helper.addUrlParams(this.pagination.url, [`session=${this.activeFeeSession.id}`])
      // var url = this.pagination.url + (this.pagination.url.split("?")[1] ? "&" : "?") +`session=${this.activeFeeSession.id}`;
      // if search query exists, add to the url as a GET param w/o disturbing other params
      if (this.search) {
        // url = endpoints.getAllFeeRecords;
        // url += (url.split("?")[1] ? "&" : "?") + "query=" + this.search;
        url = Helper.addUrlParams(url, [`query=${this.search}`]);
      }
      if (this.filter.category) {
        // url += "&category=" + this.filter.category.toString();
        url = Helper.addUrlParams(url, [`category=${this.filter.category}`]);

      }
      if (this.filter.room) {
        // url += "&room=" + this.filter.room.toString();
        url = Helper.addUrlParams(url, [`room=${this.filter.room}`]);

      }
      if (this.filter.status) {
        // url += "&status=" + this.filter.status.toString();
        url = Helper.addUrlParams(url, [`status=${this.filter.status}`]);

      }


      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: url,
        responseVar: response,
      });

      if (response) {
        // console.log(response);
        this.records = response.results;
        this.pagination.totalCount = response.count;
        this.pagination.nextUrl = response.next;
      }
    },


    async getExportData() {
      this.export_in_progress = true;
      var response;
      var url = endpoints.getAllFeeRecords + `?session=${this.activeFeeSession.id}&extract=true`;
      
      if (this.search) {
        url += "&query=" + this.search;
      }
      if (this.filter.category) {
        url += "&category=" + this.filter.category.toString();
      }
      if (this.filter.room) {
        url += "&room=" + this.filter.room.toString();
      }

       if (this.filter.status) {
        url += "&status=" + this.filter.status.toString();
      }

      response = await api.handleApi({
        apiEssentials: this.essentials,
        url: url,
        responseVar: response,
      });

      if (response) {
        this.export_in_progress = false;
        return response;
      }
    },

    handleClick(value) {
      if (!value.room) {
        this.snackbar.text =
          "Classroom not assigned. Please, assign in the Students section";
        this.snackbar.visible = true;
        return;
      }
      if (!value.category) {
        this.snackbar.text =
          "Fee Category not assigned. Please, assign in the Fee Category Settings section";
        this.snackbar.visible = true;
        return;
      }
      this.$router.push({name: 'StudentFeeDetails', params: {sid: value.student.id}});
    },
    // handles api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      if (err.response) {
        console.log(err.response);
      } else {
        this.snackbar.text = "Unknown error occurred";
        this.snackbar.visible = true;
      }
    },
    getParamsString() {
      var params = "";
      if (this.options.sortBy.length > 0) {
          // get url var
          params = "&o=";
          // iterate over sortBy options and add sortby and sortdesc seperated with commas
          for (var sortOption in this.options.sortBy) {
            params +=
              (this.options.sortDesc[sortOption] ? "" : "-") +
              this.options.sortBy[sortOption];
            if (sortOption != this.options.sortBy.length - 1) params += ",";
          }

          // handles two level db model ordering
          if (params.includes("full_name")) {
            params = params.replace("full_name", "student__full_name");
          }
          if (params.includes("phone")) {
            params = params.replace("phone", "student__phone");
          }
          if (params.includes("room")) {
            params = params.replace("room", "student__room");
          }
        }

        return params;
    }
  },
  watch: {
    options: {
      async handler() {
        // console.log("something changed");
        // console.log(this.options);
        this.pagination.url =
          endpoints.getAllFeeRecords + "?page=" + this.options.page;
        var params = this.getParamsString();
        this.pagination.url += params;
        this.getAllFeeRecords();
      },
    },
    search: {
      async handler() {
        // console.log("search is getting called");
        this.options.page = 1;
        var searched = this.search;
        var self = this;
        setTimeout(function () {
          if (searched == self.search) {
            self.getAllFeeRecords();
          }
        }, 500);
      },
    },
  },

  created() {
    this.getRooms();
    this.getAllCategories();
    this.getFeeRecordsCounts();
    // this.getAllFeeRecords(); <- getting called in watch options
  },
};
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
.rounded-input {
  border-radius: 12px !important;
}
</style>